import { Box, LinkAnchor, LinkAnchorProps, ModalHeader } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { WriskTrans } from '../trans'

const tKey = TKey('components.id-check-failed-modal')

const SendTo: FunctionComponent<LinkAnchorProps> = ({ children, ...props }) => (
  <LinkAnchor href={`mailto:${children}`} variant='inline' {...props}>
    {children}
  </LinkAnchor>
)

export const IdCheckFailedModal: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <WriskTrans t={t} i18nKey={tKey('content')} components={{ SendTo: <SendTo /> }} />
    </Box>
  )
}
